<template>
    <div id="soon-overlay" class="modal modal-sm modal-success" v-bind:class="{
        'is-active': this.active,
    }">
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
            <div class="flex-card simple-shadow">
                <div class="card-body">
                    <div class="content">
                        <section class="modal-card-body">
                            هذه الخدمه تحت الإنجاز و ستكون متاحة قريبا
                        </section>
                    </div>
                    <div class="mt-20">
                        <a class="button danger-btn btn-align modal-dismiss is-bold is-medium" style="margin: 10px"
                            @click="close()">
                            <b>إغلاق</b>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "soonModal",
    props: {
        active: {
            default: false
        }
    },
    methods:{
        close(){
            this.$emit('close');
        }
    }
}
</script>

<style></style>